export const getHierarchy = (state) => state.investigation.hierarchy;
export const getInvestigationLoading = (state) => state.investigation.loading;
export const getInvestigationState = (state) => state.investigation;
export const getChosenMode = (state) => state.investigation.chosenMode;
export const getChosenItem = (state) => state.investigation.chosenItem;
export const getChosenList = (state) => state.investigation.chosenList;
export const getTreeKey = (state) => state.investigation.treeKey;
export const getTargetsLoading = (state) => state.investigation.targetsLoading;
export const getInvestigationFilters = (state) => state.investigation.filters;